<template>
  <div class="my-3">
    <div class="mb-2">
      <span>{{caption}}</span>
    </div>
    <div class="d-flex">
      <v-dialog
        v-model="dateDialog"
        width="304"
      >
        <template #activator="{on}">
          <v-btn
            outlined
            class="body-2"
            v-on="on"
          >
            <template>{{date | dateJa}}</template>
          </v-btn>
        </template>

        <v-date-picker
          v-model="date"
          locale="ja"
          full-width
          :day-format="dayFormat"
          :allowed-dates="allowDates"
          color="primary"
          @change="onChangeDate"
        />
      </v-dialog>
      <v-dialog
        v-model="timeDialog"
        width="304"
      >
        <template #activator="{on}">
          <v-btn
            outlined
            class="ml-2 body-2"
            v-on="on"
          >
            <template>{{time}}</template>
          </v-btn>
        </template>

        <time-picker
          v-if="timeDialog"
          v-model="time"
          :range="timeRange"
          :enables="timeEnables"
          @close="timeDialog = false"
        />
      </v-dialog>
    </div>
  </div>
</template>

<script>
import * as time from '@/libs/time'
import TimePicker from './TimePicker'

export default {
  name: 'PeriodTime',
  components: {
    TimePicker
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    caption: {
      type: String,
      required: true
    },
    dates: {
      type: Object,
      required: true
    },
    allow: {
      type: Object,
      required: true
    },
    value: {
      type: Date,
      required: true
    }
  },
  data () {
    return {
      date: time.format('Y-m-d', this.value),
      time: time.format('H:i', this.value),

      dateDialog: false,
      timeDialog: false
    }
  },
  computed: {
    dateFirst () {
      return time.format('Y-m-d', this.allow.begin)
    },
    dateLast () {
      return time.format('Y-m-d', this.allow.end)
    },
    timeRange () {
      const d = this.dates[this.date]
      return {
        begin: d.begin,
        end: d.end
      }
    },
    timeEnables () {
      const enables = {
        ...this.timeRange
      }
      if (this.date === this.dateFirst) {
        const begin = time.format('H:i', this.allow.begin)
        if (enables.begin < begin) {
          enables.begin = begin
        }
      }
      if (this.date === this.dateLast) {
        const end = time.format('H:i', this.allow.end)
        if (end < enables.end) {
          enables.end = end
        }
      }
      return enables
    }
  },
  watch: {
    // props value から this.date, this.time を同期する
    value (newValue) {
      this.date = time.format('Y-m-d', newValue)
      this.time = time.format('H:i', newValue)
    },

    date (newValue) {
      this.$emit('change', time.join(newValue, this.time))
    },

    time (newValue) {
      this.$emit('change', time.join(this.date, newValue))
    }
  },
  filters: {
    // ボタンに表示する日付テキスト
    dateJa (s) {
      return s ? time.format('Y年m月d日', s) : '---'
    }
  },
  methods: {
    // カレンダーの日にちフォーマット
    dayFormat (value) {
      return time.make(value).getDate()
    },

    // 利用可能範囲を判定
    allowDates (value) {
      // 店舗カレンダーに該当するか
      if (!this.dates[value] || !this.dates[value].begin) {
        return false
      }

      // allow に該当するか
      return this.dateFirst <= value && value <= this.dateLast
    },

    // 日付が変わったとき
    onChangeDate () {
      // ダイアログを閉じる
      this.dateDialog = false

      // time が店舗の営業カレンダーに該当するか
      const d = this.dates[this.date]
      if (this.time < d.begin) {
        this.time = d.begin
      } else if (d.end < this.time) {
        this.time = d.end
      }

      // time が allow.begin に該当するか
      if (this.date === this.dateFirst) {
        const hm = time.format('H:i', this.allow.begin)
        if (this.time < hm) {
          this.time = hm
        }
      }

      // time が allow.end に該当するか
      if (this.date === this.dateLast) {
        const hm = time.format('H:i', this.allow.end)
        if (hm < this.time) {
          this.time = hm
        }
      }
    }
  }
}
</script>
